import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

const Pendo = ({ children }) => {
    const userInfo = useSelector(store => store.userInfo);
    const i18n = useSelector(store => store.i18n);
    const subscriptions = useSelector(state => state.subscriptions);
    const { tocsApp, productVariantCode } = subscriptions;

    React.useEffect(() => {
        if (window.pendo && userInfo?.role && (userInfo?.userId || userInfo?.id)) {
            window.pendo.initialize({
                visitor: {
                    id: userInfo.userId || userInfo.id,
                    User_Role: userInfo.role,
                    Subscription_Type: tocsApp,
                    Primary_Language: i18n.primaryLanguage,
                    Product_Code: productVariantCode,
                    Trial_Status: userInfo.isTrialDistrict,
                },
                account: {
                    id: userInfo.districtId,
                },
            });
        }
    }, [userInfo, i18n, tocsApp, productVariantCode]);

    return <>{children}</>;
};

Pendo.propTypes = {
    children: PropTypes.node.isRequired,
};

export default Pendo;
